import useModal from '@osmosis/tailwind-ui/hooks/useModal';

export * from '@osmosis/tailwind-ui/hooks/useModal';
export type { HookProps as ModalHookProps } from '@osmosis/tailwind-ui/hooks/useModal';
export default useModal;
